@if (processes().length > 0) {
    <div class="col">
        <div class="alert alert-info mb-0">
            <h6>
                <em class="fas fa-info-circle pe-1"></em>
                {{ 'Diese Rechnung befindet sich im Freigabeprozess' | translate }}
            </h6>
            @for (process of processes(); track process.id) {
                <div class="row justify-content-center w-100 mx-auto">
                    <div class="col-lg-6 col-md-12">
                        <button
                            class="process-status-action-button btn btn-xs btn-outline-dark"
                            (click)="openProcessDialog(process)"
                        >
                            <em class="fas fa-diagram-project pe-1"></em>
                            {{ 'Prozess anzeigen' | translate }}
                        </button>
                    </div>
                </div>
            }
        </div>
    </div>
}
